import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";
import { trackEvent } from "@/lib/tracking";

export default function FloatingWhatsApp() {
    const { pathname } = useLocation();

    return (
        <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="btn-floating-whatsapp-global"
            aria-label="Falar com a Contabeleza no WhatsApp"
            onClick={() => trackEvent("whatsapp_click_floating", { page_path: pathname })}
            className="wa-pulse fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#1EBE5B] text-white shadow-[0_10px_30px_rgba(8,16,79,0.35)] transition-transform duration-200 hover:scale-105 active:scale-95 sm:bottom-7 sm:right-7"
        >
            <MessageCircle className="h-6 w-6" fill="currentColor" strokeWidth={0} />
        </a>
    );
}
